import * as S from './styles'
import { IFormDegreeModalData } from './DegreeModal/type'
import { IFormDegreeModalData as IFormDegreeModalDataEdit } from './DegreeItem/DegreeEditModal/type'
import { IDegree } from 'app/api/degree/model/management'
import { IDegreeClassification } from 'app/api/degreeclassification/model/management'
import DegreeItem from './DegreeItem'

interface IProps {
  degreeClassificationOptions: IDegreeClassification[]
  degreeOptions: IDegree[]
  degrees?: IFormDegreeModalData[]
  onRemove?: (key: number) => void
  onUpdate?: (key: number) => void
  onEdit: (values: IFormDegreeModalDataEdit) => void
}

export const DegreeList = ({
  degrees,
  degreeOptions,
  degreeClassificationOptions,
  onRemove,
  onUpdate,
  onEdit,
}: IProps) => {
  return (
    <S.DegreeWrapper>
      {degrees?.map((degree, index) => {
        const fondDegree = degreeOptions?.find(
          degreeOption => degreeOption._id === degree.degree,
        )

        const fondDegreeClassification = degreeClassificationOptions?.find(
          degreeOption => degreeOption._id === degree.degreeClassification,
        )

        let documentImageUrl =
          degree?.document &&
          degree?.document[0] &&
          degree?.document[0].response?.data?.imageUrl

        if (!documentImageUrl) {
          documentImageUrl = degree?.document?.url
        }

        return (
          <DegreeItem
            key={index}
            degree={fondDegree}
            degreeClassification={fondDegreeClassification}
            degreeOptions={degreeOptions}
            degreeClassificationOptions={degreeClassificationOptions}
            start={degree?.start}
            end={degree?.end}
            index={index}
            document={degree?.document}
            documentImageUrl={documentImageUrl}
            onRemove={onRemove}
            onUpdate={onUpdate}
            onEdit={onEdit}
          />
        )
      })}
    </S.DegreeWrapper>
  )
}
